import { INITIALIZING_AUTH, SIGNIN, SIGNIN_FAILED, SIGNOUT } from "./authTypes";

const initialState = {
    loading: false,
    user: null,
    error: ''
}
  
const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case SIGNIN:
            return {
                error: '',
                loading: false,
                user: action.payload
            }
        case SIGNOUT:
            return {
                error: '',
                loading: false,
                user: null
            }
        case SIGNIN_FAILED:
            return {
                error: action.payload,
                loading: false,
                user: null
            }
        case INITIALIZING_AUTH:
            return {
                ...state,
                loading: true,
            }
        //   case FETCH_USERS_SUCCESS:
        //     return {
        //       loading: false,
        //       users: action.payload,
        //       error: ''
        //     }
        //   case FETCH_USERS_FAILURE:
        //     return {
        //       loading: false,
        //       users: [],
        //       error: action.payload
        //     }
        default: return state
    }
}
  
  export default authReducer;
  